import React, { Component, useState } from "react";
import styles from "./css/MaintainHomeComp.module.css";


const home_maintain_services = [
  {
    name: "Housekeeping",
    icon: "/assets/icons/maintain-your-home/Housekeeping.svg",
  },
  {
    name: "Electrical",
    icon: "/assets/icons/maintain-your-home/Electrical.svg",
  },
  {
    name: "Carpentry",
    icon: "/assets/icons/maintain-your-home/Carpentry.svg",
  },
  {
    name: "Plumbing",
    icon: "/assets/icons/maintain-your-home/Plumbing.svg",
  },
  {
    name: "Painting",
    icon: "/assets/icons/maintain-your-home/Painting.svg",
  },
  {
    name: "Others",
    icon: "/assets/icons/maintain-your-home/Others.svg",
  },
];

export class MaintainHomeComp extends Component {
  render() {
    return (
      <div className={styles.maintainHomeComp}>
        <div className={styles.maintainHomeCompInner}>
          <div className={styles.topHeading}>
            <div className={styles.headingCont}>
              <h2>Maintaining Your Home</h2>
            </div>
            <div className={styles.descriptionCont}>
              <p>
                My definition of home maintenance is any jobs that involve
                checking, DIY, and basically maintaining(!) where you live.
              </p>
            </div>
          </div>
          <div className={styles.homeServicesCont}>
            <div className={styles.homeServicesList}>
              <div className={styles.homeServicesListInner}>
                  {
                      home_maintain_services.map((singleService, index) => (
                          <SingleService 
                          key={index}
                          service={singleService}></SingleService>
                      ))
                  }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SingleService = (props) => {
    const [service, setService] = useState(props.service)
  return (
    <div className={styles.singleService}>
      <div className={styles.iconCont}>
              <img src={service.icon} />
      </div>
      <div className={styles.serviceName}>
        <p>{service.name}</p>
      </div>
    </div>
  );
};

export default MaintainHomeComp;
